import IncubatorModel from './IncubatorModel';

export default IncubatorModel;